var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.731a7.694 7.694 0 01-2.126.583 3.67 3.67 0 001.623-2.04c-.713.426-1.5.726-2.34.894a3.689 3.689 0 00-6.383 2.523c0 .293.025.574.085.842a10.445 10.445 0 01-7.606-3.86 3.715 3.715 0 00-.505 1.865c0 1.278.658 2.41 1.64 3.067a3.644 3.644 0 01-1.668-.455v.04a3.707 3.707 0 002.956 3.627c-.3.082-.627.121-.967.121-.236 0-.475-.013-.699-.063a3.725 3.725 0 003.449 2.57 7.415 7.415 0 01-4.576 1.575c-.303 0-.593-.014-.883-.051a10.389 10.389 0 005.661 1.656c6.79 0 10.503-5.625 10.503-10.5 0-.164-.006-.321-.014-.478A7.362 7.362 0 0021 6.731z",
    fill: "#2C3032",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "bb6c2501e450e078e7dffe695ba9e485.svg";
export { SvgIconTwitter as ReactComponent };